export default class PropsComponentesConstant {
    static PROPS = {
        descricao: {
            type: String,
            required: true
        },
        opcoes: {
            type: Object,
            required: true
        },
        identificador: {
            type: String,
            required: true
        },
        idComponentePai: {
            type: String,
            default: '',
            required: false
        },
        etapaComponente: {
            type: String,
            required: true
        },
        respostaObrigatoria: {
            type: Boolean,
            required: true
        },
        respostas: {
            default: null
        },
        modulo: {
            type: String,
            required: true
        },
        localRealizacao: {
            type: String,
            required: true
        },
        resumo: {
            type: Boolean,
            default: false
        },
        resumoModulos: {
            type: Boolean,
            default: false
        }
    };
}